<template>
    <b-card>
        <div class="form-group ">
             <b-form-file
                v-model="file"
                :state="Boolean(file)"
                @change="processFileInput"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".ipa, .apk"
                ></b-form-file>
        </div>
        <div class="form-group ">
            <label for="formGroupExampleInput">Package</label>
            <input
              type="text"
              class="form-control"
              id="package"
              placeholder="Enter Package"
              v-model="appVersion.package"
              :readonly="!newApp"
            >
        </div>
        <div class="form-group ">
            <label>Version</label>
            <input
              type="text"
              class="form-control"
              id="version"
              placeholder="Enter Version"
              v-model="appVersion.version"
              :readonly="!newApp"
            >
        </div>
        <div class="form-group ">
            <label for="formGroupExampleInput">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="Enter Name"
              v-model="appVersion.label"
              required
              :readonly="!newApp"
            >
        </div>
        <div class="form-group ">
            <label for="formGroupExampleInput">Compatibility</label>
            <input
              type="text"
              class="form-control"
              id="compatibility"
              placeholder="Enter Compatibility"
              v-model="appVersion.compatibility"
              required
              :readonly="!newApp"
            >
        </div>
         <div class="form-group ">
            <label for="formGroupExampleInput">Additional Information</label>
            <input
              type="text"
              class="form-control"
              id="additional"
              placeholder="Enter Additional Information"
              v-model="appVersion.additional"
            >
        </div>
        <div class="form-group row">
            <button
            type="submit"
            class="btn b-btn create-btn save-btn col-md-4"
            >Save</button>
            <button
            type="button"
            class="btn b-btn cancel-btn col-md-4"
            >Cancel</button>
      </div>
    </b-card>
</template>
<script>
export default {
  data () {
    return {
      appVersion: {},
      file: null,
      newApp: false
    };
  },
  methods: {
    processFileInput (e) {
      this.file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
      if (this.file) {
        console.log(this.file);
        this.setFileInfo(this.file);
      }
    },
    setFileInfo (file) {
    }
  },
  created () {
  }
};
</script>
<style scoped src="@/assets/css/appstore-simform.css"></style>
